var shippingProtectionIsInited = false;

function shippingProtectionInit(selector) {
   if (window.location.href.includes("/cart")) {
     shippingProtectionIsInited = true
   }
  
  let protFeatureEl;
  let insuranceVariantId;
  let protectionToggleIn;
  let protectionToggleWrapEl;
  let protectionToggleWrapChildEls;
  let shippingProtKey = "shipping_insurance_enabled";
  let hasProtectionFeature;


  let section = document.querySelector(`${selector}`)

  let checkoutBtn = document.querySelector(
    '[name="checkout"], .cart__checkout-button'
  ); // adapt this selector to your theme
  
  if (section) {
    protFeatureEl = section.querySelector(".prot-feature");
    insuranceVariantId = protFeatureEl.getAttribute("data-shipping-prot-variant-id");
    insuranceVariantPrice = +protFeatureEl.getAttribute("data-shipping-prot-variant-price");
    
    protectionToggleIn = protFeatureEl.querySelector("#prot_switch_btn");
    protectionToggleWrapEl = protFeatureEl.querySelector(".prot_switch");
    protectionToggleWrapChildEls = Array.from(protectionToggleWrapEl.children);

    cartTotalEl = section.querySelector(".totals__total-value");
    if (protectionToggleIn) {
      hasProtectionFeature = true;
      window.has_protection_feature = true;
    }
    
    checkoutBtn = section.querySelector('[name="checkout"], .cart__checkout-button');
  }

  if (hasProtectionFeature) {
    document.addEventListener("cart-shipping-script:price-update", function (e) {
      protectionToggleIn.dispatchEvent(new Event("change"));
    });

    if (insuranceVariantId) {
      removeProtectionProduct();
    }

    protectionToggleIn.addEventListener("change", function (e) {
      let toggle = protectionToggleIn;
      protectionToggleHandler(toggle);
    });

    if (protectionToggleIn && localStorage.getItem(shippingProtKey) == "true") {
      protectionToggleIn.checked = true;
      protectionToggleIn.dispatchEvent(new Event("change"));
    } else if (protectionToggleIn.checked) {
      protectionToggleIn.checked = true;
      protectionToggleIn.dispatchEvent(new Event("change"));
    }

    if (checkoutBtn && protFeatureEl) {
      checkoutBtn.addEventListener("click", function (e) {
        if (protectionToggleIn.checked) {
          addProtectionProductAndRedirect(e);
        }
      });
    }

    function addProtectionProductAndRedirect(e) {
      e.preventDefault();
      // First, add the insurance product
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: insuranceVariantId, quantity: 1 }),
      }).then(() => {
        // Then redirect to checkout
        window.location.href = "/checkout";
      });
    }

    function protectionToggleHandler(toggle) {
      console.log('inside protectionToggleHandler(toggle)')
      if (toggle.checked) {
        protFeatureEl.classList.remove("is-disabled");
        protectionToggleWrapChildEls.forEach((child) =>
          child.classList.add("checked")
        );
        localStorage.setItem(shippingProtKey, "true");
        updatePrice(toggle)
      } else {
        protFeatureEl.classList.add("is-disabled");
        protectionToggleWrapChildEls.forEach((child) =>
          child.classList.remove("checked")
        );
        localStorage.removeItem(shippingProtKey, "true");
        updatePrice(toggle)
      }
    }

    function updatePrice(toggle) {
      if (toggle.checked) {
        let newTotalPriceCents = +window.cart_total_price + +insuranceVariantPrice;
        let formattedTotalPrice = formatMoney(newTotalPriceCents);
        
        let sectionFresh = document.querySelector(`${selector}`)
        cartTotalEl = sectionFresh.querySelector(".totals__total-value");

        if (cartTotalEl) {
          cartTotalEl.innerHTML = formattedTotalPrice;
        }
        console.log("cartTotalEl", cartTotalEl);
      } else {
        let newTotalPriceCents = +window.cart_total_price;
        let formattedTotalPrice = formatMoney(newTotalPriceCents);

        let sectionFresh = document.querySelector(`${selector}`)
        cartTotalEl = sectionFresh.querySelector(".totals__total-value");

        if (cartTotalEl) {
          cartTotalEl.innerHTML = formattedTotalPrice;
        }
        console.log("cartTotalEl", cartTotalEl);
      }
    }

    async function removeProtectionProduct() {
      if (insuranceVariantId) {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            const insuranceItem = cart.items.find(
              (item) => item.variant_id == insuranceVariantId
            );
            if (insuranceItem) {
              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: insuranceItem.key,
                  quantity: 0,
                }),
              }).then(() => {
                window.location.reload(); // Refresh to update cart
              });
            }
          });
      }
    }

    function formatMoney(
      cents,
      money_format = Shopify.money_format,
      active_currency = Shopify.currency.active
    ) {
      let value = (cents / 100).toFixed(2);

      let formatedMoney;
      if (money_format.includes("{{amount}}")) {
        formatedMoney = money_format.replace("{{amount}}", value);
      } else if (money_format.includes("{{amount_with_comma_separator}}")) {
        formatedMoney = money_format.replace(
          "{{amount_with_comma_separator}}",
          value
        );
      }

      formatedMoney = formatedMoney + ` ${active_currency}`;

      return formatedMoney;
    }
  }
}

function shippingProtection() {
  if (window.location.href.includes("/cart")) {
    if (shippingProtectionIsInited == false) {
      shippingProtectionInit('main')
    }
  } else {
    shippingProtectionInit('cart-drawer')
  }
};

shippingProtection()

document.addEventListener("cart-shipping-script:init", function (e) {
  shippingProtection();
});


// --------- theme.liquid
// <script>
//   var Shopify = Shopify || {};
//   Shopify.money_format = "{{ shop.money_format }}";
// </script>


// --------- cart.js
// if (parsedState.total_price && !isNaN(parsedState.total_price)) {
//   window.cart_total_price = parsedState.total_price
// }
// 
// if (window.shipping_protection_feature_enabled) {
//   if (window.location.href.includes("/cart")) {
//     document.dispatchEvent(new CustomEvent("cart-shipping-script:price-update", { bubbles: true }));
//   } else {
//     document.dispatchEvent(new CustomEvent("cart-shipping-script:init", { bubbles: true }));
//   }
// }